<template>
  <dialog class="modal w-screen bg-black/50"
          :open="open"
          @close="$emit('close')">
    <div class="modal-box h-[96%] max-h-[800px] w-[96%] max-w-[1200px] p-0 rounded-none">
      <div id="map"
           class="w-full h-full min-h-[200px]"></div>
      <form method="dialog">
        <div class="w-full">
          <ButtonClose />
        </div>
      </form>
    </div>
    <form method="dialog"
          class="modal-backdrop">
      <button>close</button>
    </form>
  </dialog>
</template>

<script setup lang="ts">

const props = defineProps<{ spot: SpotDetail, open: boolean }>()

import { Loader } from "@googlemaps/js-api-loader";

const marker = ref<google.maps.marker.AdvancedMarkerElement>();
const platform = usePlatformSettings().platformName;

onMounted(() => {
  watch(() => props.open, (open) => {
    if (open) {
      loadMap();
    }
  });
});


function loadMap() {
  const runtimeConfig = useRuntimeConfig();
  const apiKey = runtimeConfig.public.GOOGLE_MAPS_API_KEY as string
  const loader = new Loader({
    apiKey: apiKey,
  });

  async function initMap() {
    await loader.importLibrary("maps");
    // Request needed libraries.
    const { Map } = (await google.maps.importLibrary(
      "maps"
    )) as google.maps.MapsLibrary;
    const { AdvancedMarkerElement } = (await google.maps.importLibrary(
      "marker"
    )) as google.maps.MarkerLibrary;

    const map = new Map(document.getElementById("map") as HTMLElement, {
      center: { lat: props.spot.lat, lng: props.spot.lon },
      zoom: 16,
      gestureHandling: "greedy",
      controlSize: 25,
      mapId: platform.value === "bikeable" ? "c86932714dc4b6d7" : "bcdaeb05cd4b3dfe",
      zoomControl: true,
      mapTypeControl: true,
      scaleControl: true,
      streetViewControl: true,
      rotateControl: false,
      fullscreenControl: false
    });
    const iconElement = document.createElement('img');
    iconElement.src = props.spot.famed
      ? "/icons/mapmarker/regular-fame.png"
      : "/icons/mapmarker/regular-shame.png";

    iconElement.width = 24;
    iconElement.height = 32;

    marker.value = new AdvancedMarkerElement({
      content: iconElement,
      map: map,
      position: { lat: props.spot.lat, lng: props.spot.lon },
    });

  }

  initMap();
}
</script>

<style scoped lang="postcss"></style>
